import Vue from 'vue';
import Vuex from 'vuex';
import CommonStore from '../../store/common-store';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        common_store: CommonStore,
    },
    state: {
    },
    mutations: {
    },
});
